import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { useKioskConfiguration } from '../../contexts/kioskConfiguration/KioskConfigurationContext';
import {
  HamburgerMenuIcon
} from '@radix-ui/react-icons';
import * as AlertDialog from '@radix-ui/react-alert-dialog';

import './Header.css'
import useLanguage from '../../contexts/language/LanguageContext';
import { RootState } from '../../store/store';
import { setSelectedPage } from '../../store/slices/app/appSlice';

export const Header = (): React.ReactElement => {
  const headerMenuEnabled = useSelector((state: RootState) => state.app.headerMenuEnabled)

  const kioskConfigurationContext = useKioskConfiguration()
  const language = useLanguage();
  const dispatch = useDispatch();

  const onClickLogo = () => {
    dispatch(setSelectedPage('/'))
  }

  return <div className="header h-16 bg-layout-primary flex align-middle ps-4 pe-4 justify-between items-center">
    <img src={`${process.env.APP_DATA_LINK + kioskConfigurationContext.kioskConfiguration.logoImage}`} style={{ width: '7rem' }} className="logo cursor-pointer" onClick={onClickLogo} alt="logo" />
    {headerMenuEnabled && (
      <AlertDialog.Root>
        <DropdownMenu.Root>
          <DropdownMenu.Trigger asChild>
            <button className="IconButton" aria-label="Customise options">
              <HamburgerMenuIcon width={24} height={24} />
            </button>
          </DropdownMenu.Trigger>

          <DropdownMenu.Portal>
            <DropdownMenu.Content className="DropdownMenuContent" sideOffset={5}>
              <AlertDialog.Trigger asChild>
                <DropdownMenu.Item className="DropdownMenuItem">
                  {language.translations.general.backToHomepage}
                </DropdownMenu.Item>
              </AlertDialog.Trigger>
            </DropdownMenu.Content>
          </DropdownMenu.Portal>
        </DropdownMenu.Root>
        <AlertDialog.Portal>
          <AlertDialog.Overlay className="AlertDialogOverlay" />
          <AlertDialog.Content className="AlertDialogContent">
            <AlertDialog.Title className="AlertDialogTitle">
              {language.translations.general.confirm}
            </AlertDialog.Title>
            <AlertDialog.Description className="AlertDialogDescription">
              {language.translations.general.backToHomepageConfirm}
            </AlertDialog.Description>
            <div style={{ display: 'flex', gap: 25, justifyContent: 'flex-end' }}>
              <AlertDialog.Cancel asChild>
                <button className="Button mauve">{language.translations.general.cancel}</button>
              </AlertDialog.Cancel>
              <AlertDialog.Action asChild>
                <button className="Button red" onClick={() => {
                  dispatch(setSelectedPage('/'))
                }}>{language.translations.general.yes}</button>
              </AlertDialog.Action>
            </div>
          </AlertDialog.Content>
        </AlertDialog.Portal>
      </AlertDialog.Root>
    )}
  </div>
}
